package com.example.mystybag.communication.utils

object CommunicationUtilsHelper {
    private var communicationUtilsListener: CommunicationUtilsListener? = null

    fun setup(listener: CommunicationUtilsListener) {
        communicationUtilsListener = listener
    }

    fun logout() = communicationUtilsListener?.logout()
}

interface CommunicationUtilsListener {
    fun logout()
}